'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.default = function (strings) {
	for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		values[_key - 1] = arguments[_key];
	}

	var style = _index2.default.apply(this, [strings].concat(values));

	move_up(style);

	return style;
};

var _index = require('./index');

var _index2 = _interopRequireDefault(_index);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// moves child style classes to the surface of the style class tree
// prefixing them accordingly
function move_up(object, upside, new_name) {
	var prefix = void 0;

	if (upside) {
		upside[new_name] = object;
		prefix = new_name + '_';
	} else {
		upside = object;
		prefix = '';
	}

	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(object)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var key = _step.value;

			var child_object = object[key];

			if ((0, _helpers.is_object)(child_object) && !(0, _index.is_pseudo_class)(key) && !(0, _index.is_media_query)(key)) {
				delete object[key];
				move_up(child_object, upside, '' + prefix + key);
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}
}

// for Radium it flattens the style class hierarchy:
// moves nested style classes to the top of the naming tree
// while prefixing them accordingly
// (except modifiers and media queries)
//# sourceMappingURL=flat.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-styling/build/flat.js
// module id = 1596
// module chunks = 0